import { useFlashMessage } from "../../../../hooks/useFlashMessage";
import KarteInterface, {
  KarteCommentInterface,
} from "../../../../interfaces/KarteInterface";
import CommentItem from "../../../molecules/CommentItem";
import { useDeleteKarteComment } from "./useDeleteKarteComment";

interface Props {
  karte: KarteInterface;
  comment: KarteCommentInterface;
  studentId: string;
  sectionId: string;
}

const KarteComment = (props: Props) => {
  const { karte, comment, studentId, sectionId } = props;

  const { showErrorMessage } = useFlashMessage();

  const { mutate } = useDeleteKarteComment({
    sectionId,
    studentId,
    karteId: karte.id,
    commentId: comment.id,
  });

  const handleDeleteKarteComment = () => {
    mutate(undefined, {
      onError: () => {
        showErrorMessage("コメントの削除に失敗しました");
      },
    });
  };

  return (
    <CommentItem
      onDelete={handleDeleteKarteComment}
      senderName={comment.staffName}
      createdAt={comment.createdAt}
      comment={comment.comment}
      isDeletable={comment.isDeletable}
    />
  );
};

export default KarteComment;
